import React from 'react';
import './App.css';
import AllRoutes from "./components/AllRoutes"
import SocialSidebar from './components/layout/SocialSidebar';
import ScrollButtons from './components/common/ScrollButtons';

function App() {
  return (
    <div className="App">
      {/* <SocialSidebar /> */}
      <AllRoutes />
      <ScrollButtons />
    </div>
  );
}

export default App;
